import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { findGoodsDisplayOrderByDealerId } from './gql';
import { showErrors } from '@/utils/snack';

var DealerOrders = /*#__PURE__*/function (_Vue) {
  _inherits(DealerOrders, _Vue);

  var _super = _createSuper(DealerOrders);

  function DealerOrders() {
    var _this;

    _classCallCheck(this, DealerOrders);

    _this = _super.apply(this, arguments);
    _this.displayOrders = [];
    return _this;
  }

  _createClass(DealerOrders, [{
    key: "getGoodsOrders",
    value: function () {
      var _getGoodsOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, result, typedError;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = this.$route.params.id;
                _context.prev = 1;
                _context.next = 4;
                return this.$apollo.query({
                  query: findGoodsDisplayOrderByDealerId,
                  variables: {
                    dealerId: +id
                  }
                });

              case 4:
                result = _context.sent;

                if (result) {
                  this.displayOrders = result.data.findGoodsDisplayOrderByDealerId.displayOrders;
                }

                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                typedError = _context.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8]]);
      }));

      function getGoodsOrders() {
        return _getGoodsOrders.apply(this, arguments);
      }

      return getGoodsOrders;
    }()
  }]);

  return DealerOrders;
}(Vue);

DealerOrders = __decorate([Component({})], DealerOrders);
export default DealerOrders;